import {
  CloseDerivativePositionPopupProps,
  PartiallyCloseDerivativePositionPopup,
} from './CloseDerivativePositionPopup.container';

export default (props: CloseDerivativePositionPopupProps) => ({
  component: <PartiallyCloseDerivativePositionPopup {...props} />,
  hideCloseIcon: props.hideCloseIcon,
  title: props.title,
  closeOnClickOutside: false,
  useBottomSheet: true,
  wrapperClassName: 'derivative-order-edit-popup',
  onCloseHandler: () => {
    props.onCancel?.();
  },
  ...props,
});
